// Journey API client (Fase 2, Minha Jornada).
//
// Wraps /api/journey/*, endpoint base já tem /api configurado em apiClient.
import { api as apiClient } from "./api";

const BASE = "/journey";

export const journeyApi = {
  today: () => apiClient.get(`${BASE}/today`).then((r) => r.data),
  log: (payload) => apiClient.post(`${BASE}/log`, payload).then((r) => r.data),
  history: ({ category, days = 30 } = {}) =>
    apiClient
      .get(`${BASE}/history`, {
        params: { ...(category ? { category } : {}), days },
      })
      .then((r) => r.data),
  streak: () => apiClient.get(`${BASE}/streak`).then((r) => r.data),

  listGoals: ({ kind } = {}) =>
    apiClient
      .get(`${BASE}/goals`, { params: kind ? { kind } : {} })
      .then((r) => r.data),
  createGoal: (payload) =>
    apiClient.post(`${BASE}/goals`, payload).then((r) => r.data),
  updateGoal: (id, payload) =>
    apiClient.patch(`${BASE}/goals/${id}`, payload).then((r) => r.data),
  deleteGoal: (id) =>
    apiClient.delete(`${BASE}/goals/${id}`).then((r) => r.data),
};

export const CATEGORIES = ["spiritual", "family", "health", "purpose"];
export const CATEGORY_LABELS = {
  spiritual: "Espiritual",
  family: "Família",
  health: "Saúde",
  purpose: "Propósito",
};
